import { AnyAction } from 'redux'
import type { ApiResponse } from 'shared/types/gallery/api-response-with-metadata'
export const ADD_DEBUG_API_CALL = 'ADD_DEBUG_API_CALL'

export const addDebugApiCall = (apiCallData: ApiResponse): AnyAction => ({
  type: ADD_DEBUG_API_CALL,
  payload: apiCallData,
})
